import { IRequiredDoc } from "./types";

export const REQUIRED_DOCS: IRequiredDoc[] = [
  {
    shortName: "Passport",
    longName: "Passport",
    name: "passport",
  },
  {
    shortName: "CV",
    longName: "CV",
    name: "cv",
  },
  {
    shortName: "Diploma",
    longName: "Diploma",
    name: "diploma",
  },
  {
    shortName: "References",
    longName: "References",
    name: "references",
  },
  {
    shortName: "Transcript",
    longName: "Transcript",
    name: "transcript",
  },
  {
    shortName: "Exam cert.",
    longName: "Exam Certificate",
    name: "exam_cert",
  },
  {
    shortName: "Essay",
    longName: "Essay",
    name: "essay",
  },
  {
    shortName: "Lang. prof.",
    longName: "Language Proficiency",
    name: "language_proficiency",
  },
];

export const SECONDARY_SCHOOL_LEVEL = [
  {
    id: 1,
    name: "Elementary School",
  },
  {
    id: 2,
    name: "Middle School",
  },
  {
    id: 3,
    name: "High School",
  },
];

export const SECONDARY_SCHOOL_TYPE = [
  {
    id: 1,
    name: "Co - ed",
  },
  {
    id: 2,
    name: "Boys Only",
  },
  {
    id: 3,
    name: "Girls Only",
  },
];

export const SCHOOL_GRADE = [
  {
    id: 1,
    name: "Senior High / Secondary School",
  },
  {
    id: 2,
    name: "International Baccalaureate",
  },
  {
    id: 3,
    name: "Military",
  },
  {
    id: 4,
    name: "Special - Needs Education",
  },
  {
    id: 5,
    name: "Pre-Tertiary / Foundation",
  },
  {
    id: 6,
    name: "K-12",
  },
  {
    id: 7,
    name: "GCSE",
  },
  {
    id: 8,
    name: "IGCSE",
  },
  {
    id: 9,
    name: "A Level 1/2",
  },
  {
    id: 10,
    name: "Pathway",
  },
];
